//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  methods: {
    onHandle () {
      window.open(
        `${window.location.origin}/wec-counselor-extend-apps/stu/homepage/boya/index.html`
      )
    },
  },
}
